export let life = {};
export let event = {
  // 点击号码牌
  clickPlateNumber() {
    if (!this.unClickAble) {
      let clickTime = new Date().getTime()
      if (clickTime - this.clickTime < 500) {
        this.$emit('clickPlateNumber', this.plateNumber);
      } else {
        this.clickTime = clickTime
      }
    }
  }
};
export let watch = {};
